import React, {useRef, useMemo} from 'react'
import JoditEditor from 'jodit-react';

const TextEditor = ({title, name, handleChange, value}) => {
    const editor = useRef(null);
    // Stable config reference — avoids re-mounting the editor on every parent render
    const config = useMemo(() => ({ readonly: false, placeholder: '' }), []);
    return (
        <div className='text-editor'>
            <h6 className='title-label'>{title}</h6>
            <JoditEditor
                ref={editor}
                value={value}
                config={config}
                tabIndex={1}
                // onBlur lifts state once when the user leaves the field;
                // onChange would fire on every keystroke → parent re-render → value prop
                // change → Jodit resets cursor position making typing impossible.
                onBlur={newContent => handleChange(name, newContent)}
            />
        </div>
    );
};

export default TextEditor